<template>
  <v-dialog
      v-model="modalVisible"
      width="500"
    >
     <template v-slot:activator="{ on, attrs }">
       <slot name="default" :attrs="attrs" :on="on">
          <v-btn v-bind="attrs" v-on="on">
              <v-icon>
                mdi-plus
              </v-icon>
            {{ model }}
          </v-btn>
       </slot>
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2">
        Privacy Policy
      </v-card-title>

      <v-card-text>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
          >
          I accept
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {

  name: 'DynamicCatalogAddButton',

  props: {
    model: {
      type: String,
      required: true
    },
    app: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      modalVisible: false
    }
  },

  watch: {
  }
}
</script>

<style lang="css" scoped>
</style>
